// Compliance-clean short descriptions for catalogue cards.
//
// Rendered by ProductCard.jsx via getCardShortDescription(product). Keeps
// product.short_description (from the DB / seed) untouched so downstream
// admin views, PDP fallbacks and legacy imports still read the original
// value; only the catalogue-card render is overridden here.
//
// Every override describes composition / format / research context only —
// no dosing, no administration guidance, no therapeutic / cosmetic /
// performance claims, no "ready to use" / speed-of-use language.

const OVERRIDES = {
  // Blends — raw vials
  "glow": "Three-component research blend containing GHK-Cu, BPC-157 and TB-500.",
  "klow": "Four-component research blend containing GHK-Cu, BPC-157, TB-500 and KPV.",
  "hulk": "Research blend containing CJC-1295 No DAC and Ipamorelin.",
  "wolverine": "Research blend containing BPC-157 and TB-500.",

  // Blends — pen kits
  "glow-pen": "Pre-filled three-component peptide blend research format.",
  "klow-pen": "Pre-filled four-component peptide blend research format.",
  "hulk-pen": "Pre-filled CJC-1295 No DAC and Ipamorelin research blend format.",
  "wolverine-pen": "Pre-filled BPC-157 and TB-500 research blend format.",

  // Individual compounds
  "selank": "Synthetic heptapeptide research compound.",
  "retatrutide-pen": "Pre-filled retatrutide research format.",

  // NAD+ pen — remove "Ready to use" phrasing
  "nad-plus-pen": "Pre-filled NAD+ research format.",
};

export function getCardShortDescription(product) {
  if (!product) return "";
  return OVERRIDES[product.slug] ?? product.short_description ?? "";
}
